import { useRepositoryQuery } from '@mews-commander/data-access';
import { useOwnerIdQueryPayload } from '../../security/queries/useOwnerId';

export const useEnterpriseProfilesSearch = ({
    searchToken,
    portfolioIncluded = true,
}: {
    searchToken: string;
    portfolioIncluded?: boolean;
}) => {
    const ownerIdPayload = useOwnerIdQueryPayload();
    return useRepositoryQuery('enterpriseProfiles', 'search', {
        searchToken,
        count: 10, // todo: add infinite loading
        portfolioIncluded,
        ...ownerIdPayload,
    });
};
